"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = exports.AccordionSection = void 0;

var _react = _interopRequireWildcard(require("react"));

var _style = require("./style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var AccordionSection = function AccordionSection(_ref) {
  var title = _ref.title,
      openDefault = _ref.openDefault,
      themeColor = _ref.themeColor,
      children = _ref.children;

  var _ref2 = (0, _react.useState)(openDefault),
      _ref3 = _slicedToArray(_ref2, 2),
      isOpen = _ref3[0],
      setOpen = _ref3[1];

  var onClickTitle = (0, _react.useCallback)(function () {
    return setOpen(function (o) {
      return !o;
    });
  }, [setOpen]);
  return _react["default"].createElement(_style.StyledAccordionSection, null, _react["default"].createElement(_style.StyledAccordionButton, {
    type: "button",
    role: "button",
    onClick: onClickTitle
  }, _react["default"].createElement(_style.StyledIcon, {
    isOpen: isOpen,
    themeColor: themeColor
  }), title), _react["default"].createElement(_style.StyledAccordionContent, {
    isOpen: isOpen
  }, children));
};

exports.AccordionSection = AccordionSection;

var Accordion = function Accordion(_ref4) {
  var children = _ref4.children;
  return _react["default"].createElement(_style.StyledAccordion, null, children);
};

exports.Accordion = Accordion;